import React from 'react';
import classnames from 'classnames';
export default (props => {
  const Svg = require(`./images/${props.name}.svg`);
  const className = classnames(props.className, 'lfs-svg-inline', {
    'svg--stroke-white': props.strokeWhite
  }, {
    'svg--stroke-grey': props.strokeGrey
  }, {
    'svg--stroke-grey-dark': props.strokeGreyDark
  }, {
    'svg--stroke-grey-darker': props.strokeGreyDarker
  }, {
    'svg--stroke-blue-bright': props.strokeBlueBright
  }, {
    'svg--stroke-blue-dark': props.strokeBlueDark
  }, {
    'svg--fill-blue-bright': props.fillBlueBright
  }, {
    'svg--fill-grey': props.fillGrey
  }, {
    'svg--fill-grey-dark': props.fillGreyDark
  }, {
    'svg--fill-none': props.fillNone
  }, {
    'svg--fill-white': props.fillWhite
  }, {
    'svg--small': props.small
  });
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    style: props.style
  });
});